import { gql, TypedDocumentNode } from '@common/hooks';
import {
  WorkloadBlocksQueryCgResponse,
  WorkloadBlocksQueryVariables,
} from '@common/graphql/schema';

export const WORKLOAD_BLOCKS_QUERY: TypedDocumentNode<
  WorkloadBlocksQueryCgResponse,
  WorkloadBlocksQueryVariables
> = gql`
  query WorkloadBlocks(
    $organizationUnitId: ID!
    $roleId: ID!
    $startsAt: ISO8601DateTime!
    $endsAt: ISO8601DateTime!
  ) {
    workloadBlocks(
      organizationUnitId: $organizationUnitId
      roleId: $roleId
      startsAt: $startsAt
      endsAt: $endsAt
    ) {
      blocks {
        id
        startsAt
        endsAt
        headcount
        filled
      }
    }
  }
`;
